import config from 'config/Config';
import BaseApi from './BaseApi';
import { ProjectSummary } from 'types/store/normalized';

export class ProjectSummariesApi extends BaseApi<ProjectSummary> {
  constructor() {
    super(`${config.get('backendURL')}v2/project-summaries`);
  }
}
